export default "__VITE_ASSET__CwqpYqXH__"